import { useRef } from "react";
import type { TextInput as TextInputBase } from "react-native/Libraries/Components/TextInput/TextInput";
import { Button } from "~/components/Button";
import { TextInput, type TextInputProps } from "~/components/form/TextInput";
import { QendoIcon } from "~/components/QendoIcon";
import { Padding } from "~/constants/layout";
import { useTheme } from "~/providers/ThemeProvider";

export type SearchInputProps = Omit<TextInputProps, "left" | "right" | "inputMode">;

export const SearchInput = ({
    label = "Search",
    disabled,
    value,
    onChangeText,
    ref,
    ...textInputProps
}: SearchInputProps) => {
    const { colours } = useTheme();
    const showClear = !disabled && value?.length && onChangeText;

    const localRef = useRef<TextInputBase>(null);
    const inputRef = ref ?? localRef;

    const clearSearch = () => {
        onChangeText ? onChangeText("") : inputRef.current?.clear();
        inputRef.current?.focus();
    };

    return (
        <TextInput
            {...textInputProps}
            label={label}
            disabled={disabled}
            inputMode="search"
            ref={inputRef}
            left={() => <QendoIcon name="search" size={15} color={colours.icon.secondary} />}
            right={() =>
                showClear ? (
                    <Button
                        innerStyle={Padding.none}
                        iconSize={16}
                        variant="neutral-quiet"
                        icon="xmark"
                        onPress={clearSearch}
                        disabled={disabled}
                    />
                ) : undefined
            }
            value={value}
            onChangeText={onChangeText}
        />
    );
};
